import { useEffect, useState } from 'react';
import { config } from '../../config';
import { logError } from '../../utils/logger';
import { Meta, siteVisitsApi } from './siteVisits.api';

/**
 * Engineers, projects, purposes and their checklists — fetched once per login and shared by
 * the list, the schedule dialog and the detail page. Keyed by the token for the same reason as
 * the task module's meta: signing in as someone else does not reload the page.
 */
let cached: Promise<Meta> | null = null;
let cachedFor: string | null = null;

const currentToken = () => {
  try {
    return localStorage.getItem(config.AUTH_LS_KEYS.TOKEN);
  } catch {
    return null;
  }
};

export function useSiteVisitMeta(): Meta | null {
  const [meta, setMeta] = useState<Meta | null>(null);
  useEffect(() => {
    let alive = true;
    const token = currentToken();
    if (!cached || cachedFor !== token) {
      cachedFor = token;
      cached = siteVisitsApi.meta().catch((e) => {
        cached = null;
        cachedFor = null;
        throw e;
      });
    }
    cached
      .then((m) => alive && setMeta(m))
      .catch((e) => logError({ message: 'Could not load site visit options', error: e, code: 'SITE_VISIT_META_FAILED' }));
    return () => {
      alive = false;
    };
  }, []);
  return meta;
}
